import * as React from 'react';
import { SVGProps } from 'react';

const IconStringSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18 3H6v3h12V3ZM6 7h12v3H6V7ZM16 11H8v3.32l-2 .664v2.987l-2 1.026A3.003 3.003 0 0 0 7.003 22h.474L8 20.959h2L10.523 22h2.954L14 20.959h2L16.523 22h.474A3.003 3.003 0 0 0 20 18.997l-2-1.026v-2.987l-2-.664V11Z" />
  </svg>
);
export default IconStringSizeM;
